var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", [_vm._v(_vm._s(_vm.printDate(_vm.stat.date, "DD.MM.YYYY")))]),
    _vm._v(" "),
    _c("p", [
      _vm._v("спрос: "),
      _c("strong", [_vm._v(_vm._s(_vm.stat.call ?? 0))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("цена: "),
      _c("strong", [_vm._v(_vm._s(_vm.stat.price ?? 0))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("наличие: "),
      _c("strong", [_vm._v(_vm._s(_vm.stat.stores ?? 0))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("потенциал: "),
      _c("strong", [
        _vm._v(
          _vm._s(
            Math.round(_vm.stat.potential / 1000).toLocaleString("ru-RU")
          ) + "k"
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }